import { render } from "./Footer.vue?vue&type=template&id=ad5fe7c0&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=ad5fe7c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ad5fe7c0"

export default script